import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Container, Row, Col, Button } from "reactstrap";
import Banner from "../Banner/Banner";
import { setHeaderTitle } from "../../actions/HeaderActions";
import { getDetails, getInterests } from "../../actions/AccountActions";
import { show, hide } from "../../actions/ActivityIndicatorActions";
import { checkAccess } from "../../actions/WelcomeActions";
import { FormattedMessage } from "react-intl";
import { sendData } from "../../analytics/sendData";


class DemoMaxisWelcome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSent: false,
    };
  }

  componentWillMount() {}
  componentDidMount() {
    document.body.classList.add("welcome-page-body", "maxis-welcome-page-body");
    this.props.setHeaderTitle("!Más de 300 juegos html5 online!");
  }

  componentWillUnmount() {
    sendData("", "", "", "viewed", { page: "homepage" });
    document.body.classList.remove("welcome-page-body");
  }
  
  render() {
    let androidBtnStyle = {};
    
    let banner = [
      {
        imgUrl: "./img/Welcome-Page.png",
          offer: "",
          game_name: "",
          category_name: "",
      }
    ];
    console.log("welcome here");

    return (
      <div>
        <div className="welcome-page">
          <Banner bannerData={banner} />
            <div className="category-options-wrap">
              <div className="category-options-inner">
                <Row className="justify-content-center">
                  <Col xs="12">
                    <h6 className="explore-text white-text-color">
                      <FormattedMessage
                        id="welcome.text.gamiclub"
                        defaultMessage="EXPLORE THE BEST CONTENT ONLINE TODAY!"
                      />
                    </h6>
                  </Col>
                </Row>
                <Row className="justify-content-center">
                  <Col>
                    <div className="buttons-wrap">
                      <div className="games-btn">
                        <a href="#/demo-maxis/html">
                          <i className="fa fa-html5 fa-gradient-gamiclub" aria-hidden="true"></i>
                          <span className="btn-text">
                            <FormattedMessage id="html5" defaultMessage="HTML5" />
                            <span style={{ color: "lightgreen"}} className="games-text">
                              <FormattedMessage
                                id="games"
                                defaultMessage="games"
                              />
                            </span>
                          </span>
                        </a>
                      </div>
                      <div className="games-btn" style={androidBtnStyle}>
                        <a href="#/demo-maxis/android">
                          <i className="fa fa-html5 fa-gradient-gamiclub" aria-hidden="true"></i>
                          <span className="btn-text">
                            <FormattedMessage id="android-upper" defaultMessage="ANDROID"/>
                            <span style={{ color: "lightgreen" }} className="games-text">
                              <FormattedMessage
                                id="games"
                                defaultMessage="games"
                              />
                            </span>
                          </span>
                        </a>
                      </div>
                      <div className="games-btn">
                        <a href="#/demo-maxis/video">
                          <i
                            className="fa fa-video-camera fa-gradient-gamiclub"
                            aria-hidden="true"
                          ></i>
                          <span className="btn-text">
                            <FormattedMessage
                              id="videos"
                              defaultMessage="VIDEOS"
                            />
                            <span
                              style={{ color: "lightgreen" }}
                              className="games-text"
                            >
                              <FormattedMessage
                                id="vid-player"
                                defaultMessage="player"
                              />
                            </span>
                          </span>
                        </a>
                      </div>
                    </div>
                  </Col>
                </Row>
              <Row className="justify-content-center">
                <Col xs="12">
                  <h6 className="white-text-color kazakh-text">
                    <FormattedMessage id="kazakhOnly" defaultMessage=" " />
                  </h6>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    access: state.WelcomeReducer,
    user: state.AuthenticationReducer,
    loader: state.ActivityIndicatorReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      show,
      hide,
      checkAccess,
      getDetails,
      getInterests,
      setHeaderTitle,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(DemoMaxisWelcome);



// WEBPACK FOOTER //
// ./src/components/DemoPage/DemoMaxisWelcome.js